import { deepMerge } from '../utils/objectUtils';
/**
 * Manages application context for widgets
 */
export class WidgetContextManager {
    constructor(initialContext) {
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contextUpdateKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.context = initialContext;
        this.contextUpdateKey = `__WIDGET_CONTEXT_UPDATE_${Date.now()}`;
    }
    /**
     * Updates the application context
     * @param data New context data to set
     * @param options Configuration options
     * @param options.merge Whether to deep merge with existing context (default: true)
     * @returns This instance for chaining
     */
    setContext(data, options) {
        const shouldMerge = options?.merge !== false;
        if (shouldMerge) {
            this.context = deepMerge(this.context, data);
        }
        else {
            this.context = { ...this.context, ...data };
        }
        return this;
    }
    /**
     * Removes a key from the application context
     * @param key The key to remove
     * @returns This instance for chaining
     */
    removeContext(key) {
        if (this.context && typeof this.context === 'object') {
            const newContext = { ...this.context };
            delete newContext[key];
            this.context = newContext;
        }
        return this;
    }
    /**
     * Clears the entire application context
     * @returns This instance for chaining
     */
    clearContext() {
        this.context = {};
        return this;
    }
    /**
     * Gets the current application context
     * @returns The current context
     */
    getContext() {
        return this.context;
    }
    /**
     * Gets the context update key used for notifications
     * @returns The context update key
     */
    getContextUpdateKey() {
        return this.contextUpdateKey;
    }
}
//# sourceMappingURL=WidgetContextManager.js.map